import { styled } from "styled-components";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

const Step3 = ({ serviceType, onServiceTypeChange }) => {
  return (
    <FormControl>
      <RadioGroup defaultValue="pdf-file" name="receive-type">
        <FormControlLabel
          value="pdf-file"
          defaultChecked
          checked={serviceType == "PDF Sent to Email"}
          control={<Radio />}
          label="PDF file sent to my email."
          onChange={() => onServiceTypeChange("PDF Sent to Email")}
        />

        <FormControlLabel
          value="video-meeting"
          control={<Radio />}
          label="Video meeting."
          checked={serviceType == "Video Meeting"}
          onChange={() => onServiceTypeChange("Video Meeting")}
        />

        <FormControlLabel
          value="audio-call"
          control={<Radio />}
          label="Audio call."
          checked={serviceType == "Phone Call"}
          onChange={() => onServiceTypeChange("Phone Call")}
        />
      </RadioGroup>
    </FormControl>
  );
};

const Container = styled.div``;

export default Step3;
